<template>
	<div>
		<div v-if="password==true">
			<el-dialog title="智能客服-重置密码" :visible.sync="password" @close="close" class="tanchuang" :close-on-click-modal="false" :close-on-press-escape="false">
				<el-form :model="form">
					<div style="width: 100%;display: flex;flex-direction: column; align-items: center;line-height: 40px;">
						<div style="width: 200px;text-align: left;" class="item_font">请输入新密码</div>
						<el-input v-model="form.name" autocomplete="off" style="width: 250px;"></el-input>
						<div style="width: 200px;text-align: left;" class="item_font">再次确认输入</div>
						<el-input v-model="form.name" autocomplete="off" style="width: 250px;"></el-input>
					</div>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="password = false" class="item_font">取 消</el-button>
					<el-button type="primary" @click="confirm(2)" class="item_font">确 定</el-button>
				</div>
			</el-dialog>
		</div>
		<div v-if="success==true">
			<el-dialog title="智能客服-密码修改成功提示" :visible.sync="success" @close="close" class="tanchuang" :close-on-click-modal="false" :close-on-press-escape="false">
				<div class="item_font">密码修改成功，请重新登录</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="success = false" class="item_font">取 消</el-button>
					<el-button type="primary" @click="confirm(3)" class="item_font">确 定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				code: true,
				password: true,
				success: false,
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
			}
		},
		methods: {
			confirm(num) {
				if (num == 1) {
					this.code = false
					this.password = true
					// this.$emit('confirm', 1)
				} else if (num == 2) {
					this.password = false
					this.success = true
					// this.$emit('confirm', 2)
				} else {
					// this.$emit('confirm', 3)
					// this.success = false
					// this.code = true
				}
			},
			close() {
				// this.$emit('close', '')
				this.code = true
			}
		}
	}
</script>

<style>
	.tanchuang {
		height: 600px;
	}

	.input {
		width: 100px;
		background-color: #000080;
	}
</style>
